import React from "react";

export default function SearchUser() {
	return <div></div>;
}
